import React from "react";
import { Link } from "react-router-dom";
import { StrongifierCompletedWorkoutV2 } from "src/models/strongifier-completed-workout-v2";
import {
  formatActivityDate,
  getActivityMetrics,
  getActivityVisual,
} from "./activity-format";

interface RecentWorkoutsProps {
  workouts: StrongifierCompletedWorkoutV2[];
  loading: boolean;
  onOpen: (workoutId: string) => void;
}

export const RecentWorkouts: React.FC<RecentWorkoutsProps> = ({
  workouts,
  loading,
  onOpen,
}) => {
  const recent = workouts.slice(0, 5);

  return (
    <section className="home__card">
      <div className="home__card-header">
        <div className="home__card-title">Recent workouts</div>
        <Link to="/workouts" className="home__card-link">
          View all →
        </Link>
      </div>
      {loading && <div className="home__empty">Loading workouts…</div>}
      {!loading && recent.length === 0 && (
        <div className="home__empty">
          No workouts yet — upload a .fit file to get started.
        </div>
      )}
      {!loading &&
        recent.map((workout) => {
          const visual = getActivityVisual(workout.activity_type);
          return (
            <div
              className="home__workout-row"
              style={{ cursor: "pointer" }}
              key={workout.id}
              onClick={() => onOpen(workout.id)}
            >
              <div
                className="home__workout-icon"
                style={{ border: `1.5px solid ${visual.ringColor}` }}
              >
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke={visual.color}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d={visual.iconPath}></path>
                </svg>
              </div>
              <div>
                <div className="home__workout-name">
                  {workout.workout_name ?? workout.activity_type ?? "Workout"}
                </div>
                <div className="home__workout-date">
                  {formatActivityDate(workout)}
                </div>
              </div>
              <div className="home__workout-metrics">
                {getActivityMetrics(workout).map((metric) => (
                  <div className="home__workout-metric" key={metric.label}>
                    <div className="home__workout-metric-value">
                      {metric.value}
                    </div>
                    <div className="home__workout-metric-label">
                      {metric.label}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
    </section>
  );
};
